/**
 * Non-block items. Ids >= ITEM_ID_BASE never collide with BlockType (0-15)
 * and share the same inventory slots (InventoryItem.blockId is a number).
 */

export const ITEM_ID_BASE = 100;

export enum ItemType {
  APPLE = 100,
  PORKCHOP = 101,
  BEEF = 102,
  CHICKEN_MEAT = 103,
  STICK = 105,
  // Materials
  COAL = 106,
  IRON_INGOT = 107,
  DIAMOND_GEM = 108,
  // Cooked food (from the furnace)
  COOKED_PORKCHOP = 120,
  COOKED_BEEF = 121,
  COOKED_CHICKEN = 122,
  // Wooden tools
  WOODEN_PICKAXE = 110,
  WOODEN_AXE = 111,
  WOODEN_SHOVEL = 112,
  WOODEN_SWORD = 113,
  // Stone tools
  STONE_PICKAXE = 114,
  STONE_AXE = 115,
  STONE_SHOVEL = 116,
  STONE_SWORD = 117,
  // Iron tools
  IRON_PICKAXE = 130,
  IRON_AXE = 131,
  IRON_SHOVEL = 132,
  IRON_SWORD = 133,
  // Diamond tools
  DIAMOND_PICKAXE = 140,
  DIAMOND_AXE = 141,
  DIAMOND_SHOVEL = 142,
  DIAMOND_SWORD = 143,
}

export type FoodDef = {
  name: string;
  hunger: number;
  saturation: number;
};

// Food values adapted from minecraft.wiki — cooking roughly doubles them.
export const FOOD_DEFS: Record<number, FoodDef> = {
  [ItemType.APPLE]: { name: "Maçã", hunger: 4, saturation: 2.4 },
  [ItemType.PORKCHOP]: { name: "Costela crua", hunger: 3, saturation: 1.8 },
  [ItemType.BEEF]: { name: "Bife cru", hunger: 3, saturation: 1.8 },
  [ItemType.CHICKEN_MEAT]: { name: "Frango cru", hunger: 2, saturation: 1.2 },
  [ItemType.COOKED_PORKCHOP]: { name: "Costela assada", hunger: 8, saturation: 6 },
  [ItemType.COOKED_BEEF]: { name: "Bife assado", hunger: 8, saturation: 6 },
  [ItemType.COOKED_CHICKEN]: { name: "Frango assado", hunger: 6, saturation: 4 },
};

export function isFood(id: number): boolean {
  return FOOD_DEFS[id] !== undefined;
}

/** True for ids that can be placed in the world as blocks. */
export function isPlaceableBlock(id: number): boolean {
  return id > 0 && id < ITEM_ID_BASE;
}
